export const TOOLTIP_SHADOWS = ['0px 0px 8px 0px', '0px 4px 8px 0px', '0px -4px 8px 0px'];
export const TOOLTIP_POSITION = ['top', 'bottom', 'top-start', 'top-end', 'bottom-start', 'bottom-end'];
export const extractShadowColor = (boxShadow: string | null): string | undefined => {
  const COLOR_REGEX = /#[0-9a-fA-F]{3,6}|rgba?\([^)]+\)|hsla?\([^)]+\)/;
  const match = boxShadow?.match(COLOR_REGEX);
  if (match) {
    return match[0];
  } else {
    return;
  }
};
